module.exports = __webpack_public_path__ + "static/media/arrow-comments.461b030a.svg";